import React from 'react';

/** Day numbers offered: every flagged day, the next free one, and the current choice. */
const dayOptions = (pages, current) => {
  const daily = pages.filter((p) => p.report_kind === 'daily');
  const used = daily.filter((p) => p.day_number).map((p) => p.day_number);
  const next = Math.max(0, ...daily.map((p) => p.day_number || 0)) + 1;
  return [...new Set([...used, next, current || 1])].sort((a, b) => a - b);
};

const hasOtherOfficial = (pages, selectedId, kind, day) => pages.some((p) => (
  p.id !== selectedId
  && p.is_official
  && p.report_kind === kind
  && (kind === 'full' || p.day_number === Number(day))
));

/**
 * How DigWatch should treat this version: not at all, as the full event report or as a daily report.
 * `onChange` receives only the field that changed.
 */
export default function DigwatchFlagFields({ scopeId, pages, selectedId, reportKind, dayNumber, takeOfficial, disabled, onChange }) {
  return (
    <div className="custom-reports-flag-row">
      <label className="custom-reports-field" htmlFor={`custom-report-kind-${scopeId}`}>
        <span>DigWatch</span>
        <select
          id={`custom-report-kind-${scopeId}`}
          className="custom-reports-control"
          value={reportKind}
          onChange={(e) => onChange({ report_kind: e.target.value, take_official: Boolean(e.target.value) })}
          disabled={disabled}
        >
          <option value="">No flag — just testing</option>
          <option value="full">Full event report</option>
          <option value="daily">Daily report</option>
        </select>
      </label>

      {reportKind === 'daily' && (
        <label className="custom-reports-field custom-reports-field-day" htmlFor={`custom-report-day-${scopeId}`}>
          <span>Day</span>
          <select
            id={`custom-report-day-${scopeId}`}
            className="custom-reports-control"
            value={dayNumber}
            onChange={(e) => onChange({ day_number: Number(e.target.value) })}
            disabled={disabled}
          >
            {dayOptions(pages, dayNumber).map((day) => (
              <option key={day} value={day}>
                Day {day}{hasOtherOfficial(pages, null, 'daily', day) ? ' · official' : ''}
              </option>
            ))}
          </select>
        </label>
      )}

      {reportKind && hasOtherOfficial(pages, selectedId, reportKind, dayNumber) && (
        <label className="custom-reports-flag-official">
          <input
            type="checkbox"
            checked={takeOfficial}
            onChange={() => onChange({ take_official: !takeOfficial })}
            disabled={disabled}
          />
          Take official flag
        </label>
      )}
    </div>
  );
}
